module.exports = __webpack_public_path__ + "07_long_black.242671df.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/07_long_black.png
// module id = 5VNa
// module chunks = 0